import { render, staticRenderFns } from "./StatsChart.vue?vue&type=template&id=31017035&scoped=true&"
import script from "./StatsChart.vue?vue&type=script&lang=js&"
export * from "./StatsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31017035",
  null
  
)

export default component.exports